import { MD_SCREEN_MIN } from 'modules/Styleguide';

export const SCREEN_BREAKPOINTS = {
  SMALL_DESKTOP: 1120,
  TABLET: MD_SCREEN_MIN,
  MOBILE: 480,
};
